var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoImage2 = function SvgNoImage2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1 1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1v1H0",
    fill: "#fff"
  })));
};
export { SvgNoImage2 as ReactComponent };